import React from 'react';
import CommonFolderBody from '@rd-web-markets/shared/dist/folders_and_files/modal/CommonFolderBody';
import FolderValidationWarning from './FolderValidationWarning';
import TypeCheckboxes from './TypeCheckboxes';
const FolderBody = _ref => {
  let {
    body,
    setBody,
    userClaimGroupAbilities
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CommonFolderBody, {
    body: body,
    setBody: setBody
  }), /*#__PURE__*/React.createElement(FolderValidationWarning, null), /*#__PURE__*/React.createElement(TypeCheckboxes, {
    body: body,
    setBody: setBody,
    labelText: 'folder_type',
    userClaimGroupAbilities: userClaimGroupAbilities
  }));
};
export default FolderBody;